import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fd2f5fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "datepicker-navigation-controls" }

import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "tir-style-system/icons/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'navigation-controls',
  emits: ["next", "back"],
  setup(__props, { emit }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmButton), {
      variant: _unref(TirPmButtonVariantEnum).LinkState,
      size: _unref(TirPmButtonSizeEnum).Small,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
    }, {
      leftSlot: _withCtx(() => [
        _createVNode(_unref(ChevronLeftIcon))
      ]),
      _: 1
    }, 8, ["variant", "size"]),
    _createVNode(_unref(TirPmButton), {
      variant: _unref(TirPmButtonVariantEnum).LinkState,
      size: _unref(TirPmButtonSizeEnum).Small,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('next')))
    }, {
      leftSlot: _withCtx(() => [
        _createVNode(_unref(ChevronRightIcon))
      ]),
      _: 1
    }, 8, ["variant", "size"])
  ]))
}
}

})